var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"is-edit-name":false,"resource":"rbacclusterrolebindings"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }